export default {
  addOns: 'Dodatki',
  all: 'Wszystkie',
  browse: 'Przeglądaj',
  buyTickets: 'Kup bilety',
  countSelected: 'Wybrano {{count}}',
  joinWaitlist: 'Dołącz do listy oczekujących',
  joining: 'Dołączanie',
  salesEnded: 'Sprzedaż zakończona',
  schedule: 'Harmonogram',
  soldOut: 'Wyprzedane',
  tickets: 'Bilety',
  noDatesAvailable: 'Brak dostępnych dat',
  seeMoreDates: 'Zobacz więcej dat',
  about: 'O wydarzeniu',
  agenda: 'Program',
  menu: 'Menu',
  included: 'W cenie',
  viewMore: 'Zobacz więcej',
  viewLess: 'Zobacz mniej',
  location: 'Lokalizacja',
  time: 'Czas',
  at: 'o',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Brak dostępnych godzin w tym dniu dla tej liczby osób',
  availableTimes: 'Dostępne godziny',
  waitlist: 'Lista oczekujących',
  continue: 'Kontynuuj',
  ticketsAreNoLongerAvailable: 'Bilety nie są już dostępne.',
  checkOutOutOtherExperiences: 'Sprawdź nasze inne doświadczenia!',
  viewExperiences: 'Zobacz doświadczenia',
  from: 'od',
  cancellationPolicy: 'Polityka anulowania',
  rsvp: 'RSVP',
  nights: 'noce',
  request: 'Zapytanie',
  arrival: 'Przyjazd',
  departure: 'Wyjazd',
};
